import { render, staticRenderFns } from "./MarketplaceTable.vue?vue&type=template&id=481bffdc&scoped=true&"
import script from "./MarketplaceTable.vue?vue&type=script&lang=js&"
export * from "./MarketplaceTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceTable.vue?vue&type=style&index=0&id=481bffdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bffdc",
  null
  
)

export default component.exports